import { defineMessages } from 'react-intl';

const messages = defineMessages({
  /* FiltersContainer */

  buttonFilterTemplate: 'Filters ({numFilters})',
  buttonRoomsTemplate: '{numRooms} Rooms',
  buttonDatesTemplate: '{labelStartDate} - {labelEndDate}',
  // Dates
  startDate: 'Start Date',
  endDate: 'End Date',
  dates: 'Dates',
  apply: 'Apply',
  reset: 'Reset',
  headerDates: 'Select Dates',
  datesDisclaimer: 'Note: Individual crew dates can be selected when completing the booking',
  // ROOMS
  rooms: 'Rooms',
  headerRooms: 'Select Rooms',
  roomsDescription: 'Total number of rooms',
  roomsButtonLabel: 'UPDATE RESULTS',
  roomsDisclaimerMobile: 'Note: The number of rooms can be changed up to the first date of your stay',
  roomsDisclaimerDesktop: '* The number of rooms can be changed up to the first date of your stay',
  // Filters
  headerFilter: 'Select Filters',
  propertyTypeTitle: 'Property Type',
  propertyTypesDescription: 'Select a property type',
  distanceTitle: 'Distance',
  distanceDescriptionTemplate: 'Within {distance} of: {location}',
  priceRangeTitle: 'Price Range',
  priceRangeDescription: 'Per room, per night',
  // eslint-disable-next-line no-template-curly-in-string
  priceRangeNumberFormat: '${price}',
  amenitiesTitle: 'Amenities',
  amenitiesDescription: 'Select all that apply',
  seeMoreLabel: 'See More +',
  instantBookTitle: 'Instant Book',
  instantBookDescription: 'Book now, no wait.',
  clearButtonLabel: 'Clear',
  updateButtonLabel: 'UPDATE MAP',

  /* Drawer */

  openText: 'See all listings ({totalProperties})',
  closeText: 'View on Map',
  openTextError: 'An error occurred.',

  // Drawer select
  options: `
    Relevance,
    Alphabetical {LtH},
    Alphabetical {HtL},
    Distance {LtH},
    Distance {HtL},
    Price {LtH},
    Price {HtL}
    `, // Derived from GraphQL SearchQueryOptions type; LtH = Low To High, HtL = High To Low
  selectLabel: 'Sort by:',
  propertiesLabel: '{currentProperties} properties',

  // NoResults
  noResultsTitle: "Didn't find what you were looking for?",
  noResultsSubtitle: 'We offer discounts of up to 30% through our partner properties in the area',

  suggestionLabel: 'Please try:',
  suggestionList: `
    Adjusting the price and/or distance ranges in the search filters,
    Broadening your search criteria,
    Check the spelling or try alternate spellings,
    Contacting us. We'll find what you need
  `,

  // Error
  errorResultsTitle: 'There was an error processing your request.',
  errorResultsDescription: 'For any questions or concerns, please contact LodgeLink at',

  // PropertyItem card
  propertyDescription: '{city}, {region}',
  propertyDescriptionWithDistance: '{city}, {region} - {distance} {showDistanceIn} away',
  startingAtLabel: 'Starting at',
  priceFrequencyLabel: 'night',
  callForPricingLabel: 'Please Call for Pricing',
  callForAvailability: 'Chat For Availability',

  /* MapLayerPanel */
  detailedLayerButtonLabel: 'Detailed Layers',

  preferredPropertiesLabel: 'Preferred Properties',
  relevantPropertiesLabel: 'Relevant Properties'
});

export default messages;
